var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8dd463;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 742.36,
    cy: 543.33,
    r: 286.17
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bubble_3",
    "data-name": "bubble 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 742.36,
    cy: 543.33,
    r: 286.17
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M771,377.73c-6.49,28,6.7,59.54,31.28,74.52s58.67,12.24,80.5-6.52,29.64-52.11,18.36-78.59C875.9,307.86,785.67,314.4,771,377.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M647.42,685.37c-21,2.24-42.25,16.88-44.77,37.83-2.35,19.58,11.82,37.42,27.63,49.2C670.36,802.24,727,808,772.33,786.92c13.62-6.35,26.89-15.76,32.41-29.74,8.42-21.33-5-46.54-24.79-58-20.31-11.79-42.88-11.56-65.33-8.94C691.54,692.89,670.41,682.92,647.42,685.37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects22);
export default __webpack_public_path__ + "static/media/objects-22.da44669076b27203c870df1f2746783c.svg";
export { ForwardRef as ReactComponent };